export enum RelatedArticlesBackgroundColor {
  WHITE,
}
